import careers from './technicalCareerSchools.json';

const normalizeName = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();

export function getTechnicalCareerSchool(career) {
  if (!career) return null;
  const name = normalizeName(career.name);
  return careers.find(entry => normalizeName(entry.name) === name)?.school || null;
}
